// **نصيحةُ اليوم** (قرار المالك 22/09/2026: «خلّي عندك ١٠٠ نصيحة في المبيعات الخاصة
// بحجز تذاكر الطيران والفنادق، والنصيحة ماتبقاش كبيرة — كل يوم موظف يدخل يدخله نصيحة
// تفيده غير اليوم اللي بعده، بشكل تلقائي لمدة ١٠٠ يوم، وبعد كده لخبطهم تاني وهكذا»).
//
// **الاختيار حسابٌ لا عشوائيةٌ ولا تخزين**: من رقم اليوم في التقويم. فنفسُ اليوم يعطي
// نفسَ النصيحة لكل الموظفين — يتكلّمون عنها بينهم — ولا يعتمد على خادمٍ يُسأل ولا على
// ذاكرةِ متصفّحٍ تُمسح. ومن يفتح البرنامج ثلاث مرّات في اليوم يرى النصيحة نفسها.
//
// **والترتيب يتبدّل كل دورة**: الدورة بطول القائمة (١٠٤ نصيحة — زادت أربعًا عن المئة
// المطلوبة ولم يُحذف منها شيء)، ولكلّ دورةٍ خلطةٌ مولَّدة من رقمها. فلا يحفظ أحدٌ
// التسلسل ولا يتوقّع نصيحة الغد، وتعود النصيحة بعد دورةٍ كاملة في موضعٍ آخر.
//
// وكلُّها قصيرة: سطرٌ يُقرأ في ثانيتين ويُعمل به اليوم. النصيحةُ الطويلة تُغلق بلا قراءة.

/** نصائحُ بيع تذاكر الطيران والفنادق — عملية، لا شعارات. */
export const TIPS: readonly string[] = [
  // ── قبل ما تتكلّم ────────────────────────────────────────────────────────
  'قبل ما ترد على العميل، افتح تاريخه في البرنامج — كلمة «زي رحلتك للرياض السنة اللي فاتت» بتكسب ثقة فورًا.',
  'اسأل عن تاريخ السفر والرجوع وعدد الأفراد قبل أي سعر — السعر بلا تفاصيل وعدٌ هتتراجع عنه.',
  'اعرف سبب السفر: شغل ولا سياحة ولا علاج؟ كل واحد بيشتري حاجة مختلفة بنفس التذكرة.',
  'اسأل: «مرتاح لأي وقت قيام؟» — العميل اللي بيكره الفجر مش هيقبل أرخص تذكرة لو قيامها 4 الفجر.',
  'خد رقم واتساب بديل من أول مكالمة — الرقم الواحد بيضيع، والحجز بيضيع معاه.',
  'اكتب اسم العميل زي ما هو في الباسبور من أول لحظة — التعديل بعد الإصدار بيتكلّف.',
  'قبل ما تعرض، اعرف ميزانيته بسؤال مهذّب: «حضرتك حاطط في بالك حدود كام؟» — بيوفّر عليك عشر مكالمات.',
  'اسأل عن الأطفال وسنّهم قبل التسعير — سعر الطفل والرضيع بيغيّر الإجمالي تمامًا.',
  'لو العميل بيسأل لمجموعة، اعرف العدد النهائي قبل ما تحجز — الجروب بيتغيّر والأسعار بتطير.',
  'حضّر بديلين قبل ما تكلّمه: واحد أوفر وواحد أريح — الاختيار بيقفل أسرع من الرأي الواحد.',

  // ── العرض والتسعير ───────────────────────────────────────────────────────
  'اعرض سعرين أو تلاتة بس — أكتر من كده بيحيّر العميل فيأجّل القرار.',
  'ابدأ بالأغلى وانزل — العميل بيقيس اللي بعده على أول رقم سمعه.',
  'قول السعر شامل كل حاجة من الأول: تذكرة + شنطة + خدمة. المفاجأة بعدين بتلغي الحجز.',
  'وضّح الفرق بين السعرين بجملة واحدة: «الأغلى بيوفّرلك ترانزيت ساعتين بدل تسعة».',
  'ما تقولش «رخيص» — قول «أوفر». الرخيص في دماغ العميل معناه أقل جودة.',
  'اكتب السعر في رسالة مكتوبة بعد المكالمة — اللي بيتقال بيتنسي واللي بيتكتب بيتحسب.',
  'حطّ تاريخ صلاحية للعرض: «السعر ده لحد النهاردة بالليل» — من غير ضغط كاذب، ده الواقع فعلًا.',
  'لو السعر غالي، ماتبرّرش — فصّل: الضرايب كام، التذكرة كام، خدمتنا كام. الشفافية بتطفّي الاعتراض.',
  'لما تقول السعر، اسكت. أول واحد يتكلّم بعد السعر بيخسر التفاوض.',
  'استخدم أداة التفقيط وحاسبة سعر البيع قبل ما ترسل — رقم غلط في عرض بيكلّفك عميل.',

  // ── تذاكر الطيران ────────────────────────────────────────────────────────
  'راجع وزن الشنطة المسموح في التذكرة قبل ما تأكّد — أكتر شكوى بتيجي من الشنطة مش من السعر.',
  'الترانزيت أقل من ساعتين مخاطرة — لو الرحلة الأولى اتأخرت، العميل يقعد في المطار والمسؤولية عليك.',
  'اتأكد إن الترانزيت في نفس المطار — تغيير المطار في مدينة غريبة كابوس للعميل.',
  'اسأل عن التأشيرة قبل الإصدار — عميل بيسافر بتذكرة وهو محتاج ترانزيت فيزا مشكلة كبيرة.',
  'اتأكد إن الباسبور ساري 6 شهور على الأقل — ده أكتر سبب بيمنع الراكب من الصعود.',
  'اكتب الاسم بالظبط زي الباسبور — حرف ناقص ممكن يمنع الصعود ويكلّف تذكرة جديدة.',
  'وضّح للعميل شروط التغيير والاسترداد قبل الدفع — مش بعد ما يطلب يغيّر.',
  'الرحلة المباشرة أغلى بس بتبيع نفسها لكبار السن والأطفال — اعرضها لهم حتى لو مافيش طلب.',
  'قبل الإصدار بيوم، اتأكد إن مافيش تغيير في مواعيد الرحلة — الشركات بتغيّر من غير ما تبلّغ العميل.',
  'ذكّر العميل بموعد الحضور للمطار: 3 ساعات للدولي وساعتين للداخلي.',
  'اسأل: «محتاج اختيار مقعد؟» — خدمة صغيرة بتخلّي العميل يفتكرك.',
  'لو العميل بيسافر بشنطة زيادة، احسبها قبل السفر — سعرها في المطار أضعاف سعرها مقدّمًا.',
  'راجع كود المطار مش اسم المدينة — في مدن ليها أكتر من مطار والفرق ساعتين طريق.',
  'اسأل عن الوجبات الخاصة لو الرحلة طويلة — طلب مجاني وبيفرق مع العميل جدًّا.',
  'التذكرة المفتوحة مش دايمًا أوفر — احسبها للعميل بالورقة والقلم قبل ما تنصحه بيها.',

  // ── الفنادق ──────────────────────────────────────────────────────────────
  'اسأل عن موقع الفندق قبل نجومه — 5 نجوم بعيد أسوأ من 4 نجوم في قلب المكان.',
  'وضّح نظام الوجبات بالاسم: إفطار بس؟ نص إقامة؟ شامل؟ — أكتر سوء فهم بيحصل هنا.',
  'اتأكد من موعد الدخول والخروج واكتبه للعميل — الوصول الفجر من غير حجز ليلة زيادة مشكلة.',
  'اسأل عن نوع السرير: مزدوج ولا منفصل؟ — العيلة والأصحاب مش زي بعض.',
  'راجع سنّ الأطفال عند الفندق — كل فندق بيحسب الطفل بشكل مختلف والفرق بيبان في الفاتورة.',
  'وضّح لو في رسوم بلدية أو ضريبة سياحة بتتدفع في الفندق — العميل لازم يعرف قبل ما يسافر.',
  'اعرض صور الغرفة الحقيقية مش صور الدعاية — العميل اللي مااتفاجأش بيرجعلك تاني.',
  'اسأل عن إطلالة معيّنة — طلب بسيط وبيرفع رضا العميل من غير ما يكلّفك حاجة.',
  'اتأكد من سياسة الإلغاء واكتبها — «مجاني لحد كذا» بتبيع أكتر من خصم 5٪.',
  'لو الفندق بعيد عن الحرم أو المركز، قول المسافة بالدقايق مش بالكيلو — الناس بتفكر بالوقت.',
  'اسأل: «محتاج مواصلات من المطار؟» — خدمة بتزوّد قيمة الحجز وبتقلّل قلق العميل.',
  'راجع إن اسم النزيل في الفندق زي اسم الباسبور — الفنادق بتطلبه عند الدخول.',
  'الفندق اللي فيه إفطار غالبًا أوفر من غيره لعيلة — احسبها وقولها للعميل.',
  'قبل السفر بيومين، أكّد الحجز مع الفندق — التأكيد بيمنع مفاجآت الوصول.',
  'لو العميل بيحجز لعيلة كبيرة، اسأل عن غرف متجاورة — طلب مجاني وبيفرق جدًّا.',

  // ── الاعتراضات ───────────────────────────────────────────────────────────
  '«غالي» مش رفض — دي دعوة تشرح. اسأل: «غالي مقارنة بإيه؟»',
  'لما يقول «هفكّر»، اسأل: «في حاجة معيّنة محتاج توضيح ليها؟» — التأجيل غالبًا سؤال مخبّي.',
  'لو قارنك بسعر أقل، ماتقللش من غيرك — وضّح اللي هو داخل في سعرك ومش داخل في سعرهم.',
  'العميل اللي بيسأل كتير مش بيضيّع وقتك — ده أقرب واحد للحجز.',
  'ماتقولش «مش عارف» — قول «هتأكّد وأرد عليك خلال ساعة»، وارد فعلًا في الوقت.',
  'لو مالقتش اللي طلبه، اعرض أقرب حاجة ووضّح الفرق — أحسن من «مش متوفر» وقفل.',
  'لما العميل يزعل، اسمع للآخر من غير ما تقاطع — نص المشكلة بتحل بالسماع.',
  'ماتوعدش بحاجة مش مضمونة علشان تقفل الحجز — وعد مكسور بيخسّرك العميل وسمعتك.',
  'لو الغلط منك، اعترف بسرعة واعرض الحل — الاعتراف السريع بيحوّل الشكوى لولاء.',
  'العميل اللي بيقول «لأ» النهاردة ممكن يقول «أيوه» بعد شهرين — سجّل متابعة وماتقفلش الباب.',

  // ── الإقفال ──────────────────────────────────────────────────────────────
  'اسأل سؤال الإقفال بوضوح: «أحجزلك دلوقتي؟» — كتير بيخسروا الحجز لأنهم ماطلبوهوش.',
  'استخدم الاختيار مش الموافقة: «تحب الصبح ولا بالليل؟» بدل «تحب تحجز؟»',
  'وضّح إن السعر مش محجوز غير بالدفع — التأخير يوم بيغيّر السعر فعلًا.',
  'سهّل الدفع: اعرض أكتر من طريقة — كل خطوة صعبة بتقلّل فرصة الإقفال.',
  'لما يوافق، اقفل فورًا — «هبعتلك بعد شوية» بتضيّع حجوزات أكتر من أي اعتراض.',
  'بعد ما يدفع، ابعتله تأكيد مكتوب في نفس الساعة — السكوت بعد الدفع بيقلق العميل.',
  'اطلب المقدّم لو مش هيدفع كامل — المقدّم بيحوّل النية لالتزام.',
  'الحجز اللي فيه دفعة جزئية محتاج متابعة بتاريخ محدّد — سجّلها وما تعتمدش على ذاكرتك.',

  // ── المتابعة ─────────────────────────────────────────────────────────────
  'كل مكالمة تنتهي بخطوة تالية ومعاد — «هكلّمك» من غير تاريخ معناها مش هتكلّمه.',
  'سجّل المتابعة وأنت لسه في المكالمة — اللي بيتأجّل للآخر بينسى.',
  'اكتب في الملاحظات كلمة بلسان العميل — «قالي ماعندوش إجازة قبل 20» بتفتحلك المكالمة الجاية.',
  'تابع المتأخّر قبل الجديد — الرقم اللي برد عليه من يومين أقرب للحجز من رقم جديد.',
  'كلّم في الوقت اللي يرد فيه: الموظف بعد الشغل، وربّة البيت الصبح.',
  'لو مارّدش تلات مرات، غيّر القناة — واتساب برسالة قصيرة بيرد عليها ناس كتير.',
  'رسالة المتابعة تبدأ بحاجة تخصّه هو: «بخصوص رحلة دبي في ١٥…» مش «أهلًا معاك فلان».',
  'اسحب من بنك أرقامك كل يوم وكلّم اللي سحبته — الرقم اللي ما اتكلّمش بيرجع لبنكك وبتخسر يومه.',
  'الرقم اللي رفض النهاردة سجّل عليه سبب الرفض — السبب ده هو مفتاح المكالمة الجاية.',
  'خلّي عندك قايمة بالعملاء اللي سافروا الشهر اللي فات — رحلة كل سنة عادة مش صدفة.',

  // ── بعد البيع ────────────────────────────────────────────────────────────
  'ابعت للعميل رسالة قبل سفره بيوم — بتفتكره دايمًا وبتجيبلك ترشيحات.',
  'اسأله بعد الرجوع «الرحلة كانت عاملة إزاي؟» — أحسن وقت تطلب فيه تقييم.',
  'اطلب التقييم على Google وأنت واقف معاه وهو مبسوط — مش برسالة باردة بعد أسبوع.',
  'العميل المبسوط بيجيب عميلين — اسأله صراحة: «تعرف حد محتاج يسافر؟»',
  'احتفظ بصور الجواز والتذكرة والشات في مرفقات الحجز — وقت الاختلاف دي حمايتك أنت.',
  'العميل القديم أرخص من الجديد بعشر مرات — رجوعه ليك مكسب مش روتين.',
  'سجّل مناسبات عميلك: عمرة كل سنة، إجازة الصيف — وكلّمه قبل الموسم بشهر.',

  // ── الشغل والانضباط ──────────────────────────────────────────────────────
  'ابدأ يومك بمتابعات أمس المتأخرة قبل أي حاجة — دي أقرب فلوس ليك.',
  'ماتسيبش الحجز من غير مرفقات — الجواز والتذكرة والشات، دي حقك قبل ما تكون إجراء.',
  'راجع حجوزاتك اللي فيها متبقّى كل صباح — التحصيل المتأخر بيتحوّل لمشكلة بسرعة.',
  'اكتب كل تفصيلة في البرنامج مش في ورقة — الورقة بتضيع والبرنامج بيفضل.',
  'اتعلّم كود مطار جديد كل أسبوع — السرعة في الرد بتبيع.',
  'راجع سعر الصرف قبل أي عرض بالدولار أو الريال — يوم واحد بيغيّر ربحك كله.',
  'ماتقفلش اليوم وعندك رقم اتسحب وما اتكلّمش — هيرجع لبنكك وتخسر يومه.',
  'قبل ما تمشي، شوف رحلات بكره — عميل مسافر محتاج طمأنة قبل يوم السفر.',
  'خلّي عندك قايمة بالفنادق اللي عملاءك حبّوها — الترشيح من تجربة بيقفل أسرع من أي كتالوج.',
  'راجع شريحتك في خطة العمولات — لما تعرف إنت فاضلك كام حجز، شغلك بيتغيّر.',
  'اسأل زميلك اللي بيقفل أكتر منك عن جملة بيقولها — نصف المهارة بتتنقل بالكلام.',
  'المكالمة القصيرة المرتّبة أحسن من الطويلة المشتّتة — حضّر أسئلتك قبل ما ترنّ.',
  'ماتحجزش وإنت مش فاهم طلب العميل — سؤال زيادة أرخص من حجز غلط.',
  'لو حسّيت إن في حاجة غلط في الطلب، اسأل — حدسك غالبًا صح.',
  'رتّب متابعاتك بالأولوية مش بالتاريخ — عميل جاهز يحجز أهم من عشرة بيسألوا.',
  'خد استراحة خمس دقايق كل ساعة — الصوت المرهق بيبان في التليفون.',
  'اقرا شكوى عميل واحدة كل أسبوع وافهم سببها — أحسن تدريب مجاني هتلاقيه.',
  'اكتب أسعارك بخط واضح ومرتّب في الرسالة — العرض المرتّب بيبيع قبل ما يتقرا.',
  'آخر حاجة قبل ما تمشي: سجّل انصرافك — حقّك في المرتب والإجازات بيتكتب بالبصمة.',
];

/** مولّدُ أرقامٍ ببذرة — نفس البذرة تعطي نفس الترتيب في كل جهاز وكل مرّة. */
function seeded(seed: number): () => number {
  let a = (seed | 0) + 0x6D2B79F5;
  return () => {
    a = (a + 0x6D2B79F5) | 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

/** خلطةُ الدورة: ترتيبٌ كاملٌ للمواضع، يختلف باختلاف رقم الدورة ويثبت داخلها. */
function order(cycle: number, n: number): number[] {
  const rnd = seeded(cycle * 7919 + 13);
  const a = Array.from({ length: n }, (_, i) => i);
  for (let i = n - 1; i > 0; i--) {
    const j = Math.floor(rnd() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

/** مبدأُ العدّ — تاريخٌ ثابت لا يتغيّر، وإلّا تبدّلت النصائح بلا سبب. */
const EPOCH = Date.UTC(2026, 0, 1);

/**
 * نصيحةُ يومٍ بعينه (`YYYY-MM-DD`). نفسُ اليوم = نفسُ النصيحة لكل الموظفين، وبعد دورةٍ
 * كاملة تبدأ دورةٌ جديدة بترتيبٍ مختلف — فلا تُتوقَّع نصيحةُ الغد ولا تعود في موضعها.
 */
export function tipOfDay(isoDate: string): string {
  const [y, m, d] = isoDate.split('-').map(Number);
  if (!y || !m || !d) return TIPS[0];
  const days = Math.floor((Date.UTC(y, m - 1, d) - EPOCH) / 86_400_000);
  const n = TIPS.length;
  const cycle = Math.floor(days / n);
  const pos = ((days % n) + n) % n;
  return TIPS[order(cycle, n)[pos]];
}
